//libs
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

//styles
import { Count, Separator } from './styles';

//selectors
import { getTotalCount } from 'shared/store/listingV2/selectors';

//constants
const ITEMS_TEXT = 'items';
const FILL_OPACITY = '1';

const ProductCount = () => {
  const count = useSelector(getTotalCount);
  if (!count) return null;
  return (
    <>
      <Separator fillOpacity={FILL_OPACITY} />
      <Count data-at="plp-product-count">{`${count.toLocaleString()} ${ITEMS_TEXT}`} </Count>
    </>
  );
};

export default memo(ProductCount);
